import { FUNDING_AREA_LIST, reloadFundingAreaList, resetFundingAreaLists } from "./fundingArea";
import { beginLoading, endLoading } from "./loadingSpinner";
import { clearMessages, createBackendErrorMessages, createSuccessMessages, messagesReceived } from "./message";

import { MASTER_DATA_STORE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { showDialog } from "./confirmDialog";

export const REDUCER = "MASTERDATA/";

export const DESELECTED_FUNDING_AREA = REDUCER + "DESELECTED_FUNDING_AREA";
export const SELECTED_FUNDING_AREA_CHANGE = REDUCER + "SELECTED_FUNDING_AREA_CHANGE";
export const SELECTED_PROGRAM_CHANGE = REDUCER + "SELECTED_PROGRAM_CHANGE";
export const SELECTED_PROGRAM_INSTANCE_CHANGE = REDUCER + "SELECTED_PROGRAM_INSTANCE_CHANGE";

export const NEW_PROGRAM = REDUCER + "NEW_PROGRAM";
export const NEW_PROGRAM_INSTANCE = REDUCER + "NEW_PROGRAM_INSTANCE";
export const NEW_PROJECT = REDUCER + "NEW_PROJECT";

export const PROGRAM_CHANGE = REDUCER + "PROGRAM_CHANGE";
export const PROGRAM_INSTANCE_CHANGE = REDUCER + "PROGRAM_INSTANCE_CHANGE";
export const PROJECT_CHANGE = REDUCER + "PROJECT_CHANGE";

export const EDIT_PROGRAM_DIALOG_OPEN_CHANGE = REDUCER + "EDIT_PROGRAM_DIALOG_OPEN_CHANGE";
export const EDIT_PROGRAM_INSTANCE_DIALOG_OPEN_CHANGE = REDUCER + "EDIT_PROGRAM_INSTANCE_DIALOG_OPEN_CHANGE";
export const EDIT_PROJECT_DIALOG_OPEN_CHANGE = REDUCER + "EDIT_PROJECT_DIALOG_OPEN_CHANGE";

export const EDIT_PROGRAM = REDUCER + "EDIT_PROGRAM";
export const EDIT_PROGRAM_INSTANCE = REDUCER + "EDIT_PROGRAM_INSTANCE";
export const EDIT_PROJECT = REDUCER + "EDIT_PROJECT";

// state props
export const EDIT_PROGRAM_DIALOG_OPEN = "editProgramDialogOpen";
export const EDIT_PROGRAM_INSTANCE_DIALOG_OPEN = "editProgramInstanceDialogOpen";
export const EDIT_PROJECT_DIALOG_OPEN = "editProjectDialogOpen";
export const SELECTED_FUNDING_AREA_ID = "selectedFundingAreaId";
export const SELECTED_PROGRAM_INSTANCE_ID = "selectedProgramInstanceId";
export const SELECTED_PROGRAM_ID = "selectedProgramId";
export const EDITED_PROGRAM = "editedProgram";
export const EDITED_PROGRAM_INSTANCE = "editedProgramInstance";
export const EDITED_PROJECT = "editedProject";
export const PROJECT_REPORTING_REF_COUNT = "projectReportingRefCount";

const initialState = {
  [SELECTED_FUNDING_AREA_ID]: undefined,
  [SELECTED_PROGRAM_ID]: undefined,
  [SELECTED_PROGRAM_INSTANCE_ID]: undefined,
  [EDITED_PROGRAM]: {},
  [EDITED_PROGRAM_INSTANCE]: {},
  [EDITED_PROJECT]: {},
  [EDIT_PROGRAM_DIALOG_OPEN]: false,
  [EDIT_PROGRAM_INSTANCE_DIALOG_OPEN]: false,
  [EDIT_PROJECT_DIALOG_OPEN]: false
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case DESELECTED_FUNDING_AREA:
      newState = {
        ...state,
        [SELECTED_FUNDING_AREA_ID]: undefined,
        [SELECTED_PROGRAM_ID]: undefined,
        [SELECTED_PROGRAM_INSTANCE_ID]: undefined
      };
      break;
    case SELECTED_FUNDING_AREA_CHANGE:
      newState = {
        ...state,
        [SELECTED_FUNDING_AREA_ID]: action[SELECTED_FUNDING_AREA_ID],
        [SELECTED_PROGRAM_ID]: undefined,
        [SELECTED_PROGRAM_INSTANCE_ID]: undefined
      };
      break;
    case SELECTED_PROGRAM_CHANGE:
      newState = {
        ...state,
        [SELECTED_PROGRAM_ID]: action[SELECTED_PROGRAM_ID],
        [SELECTED_PROGRAM_INSTANCE_ID]: undefined
      };
      break;
    case SELECTED_PROGRAM_INSTANCE_CHANGE:
      newState = {
        ...state,
        [SELECTED_PROGRAM_INSTANCE_ID]: action[SELECTED_PROGRAM_INSTANCE_ID]
      };
      break;
    case PROGRAM_CHANGE:
      newState = {
        ...state,
        [EDITED_PROGRAM]: {
          ...state[EDITED_PROGRAM],
          [action.property]: action.value
        }
      };
      break;
    case PROGRAM_INSTANCE_CHANGE:
      newState = {
        ...state,
        [EDITED_PROGRAM_INSTANCE]: {
          ...state[EDITED_PROGRAM_INSTANCE],
          [action.property]: action.value
        }
      };
      break;
    case PROJECT_CHANGE:
      newState = {
        ...state,
        [EDITED_PROJECT]: {
          ...state[EDITED_PROJECT],
          [action.property]: action.value
        }
      };
      break;
    case NEW_PROGRAM:
      newState = {
        ...state,
        [EDIT_PROGRAM_DIALOG_OPEN]: true,
        [EDITED_PROGRAM]: {
          fundingAreaId: state[SELECTED_FUNDING_AREA_ID],
          name: ""
        }
      };
      break;
    case NEW_PROGRAM_INSTANCE:
      newState = {
        ...state,
        [EDIT_PROGRAM_INSTANCE_DIALOG_OPEN]: true,
        [EDITED_PROGRAM_INSTANCE]: {
          programId: state[SELECTED_PROGRAM_ID],
          name: ""
        }
      };
      break;
    case EDIT_PROGRAM:
      newState = {
        ...state,
        [EDIT_PROGRAM_DIALOG_OPEN]: true,
        [EDITED_PROGRAM]: action[EDITED_PROGRAM]
      };
      break;
    case EDIT_PROGRAM_INSTANCE:
      newState = {
        ...state,
        [EDIT_PROGRAM_INSTANCE_DIALOG_OPEN]: true,
        [EDITED_PROGRAM_INSTANCE]: action[EDITED_PROGRAM_INSTANCE]
      };
      break;
    case EDIT_PROJECT:
      newState = {
        ...state,
        [EDIT_PROJECT_DIALOG_OPEN]: true,
        [EDITED_PROJECT]: action[EDITED_PROJECT]
      };
      break;
    case NEW_PROJECT:
      newState = {
        ...state,
        [EDIT_PROJECT_DIALOG_OPEN]: true,
        [EDITED_PROJECT]: {
          programInstanceId: state[SELECTED_PROGRAM_INSTANCE_ID],
          name: "",
          category: "IND"
        }
      };
      break;
    case EDIT_PROGRAM_DIALOG_OPEN_CHANGE:
      newState = {
        ...state,
        [EDIT_PROGRAM_DIALOG_OPEN]: action[EDIT_PROGRAM_DIALOG_OPEN],
        [EDITED_PROGRAM]: action[EDIT_PROGRAM_DIALOG_OPEN] ? state[EDITED_PROGRAM] : {}
      };
      break;
    case EDIT_PROGRAM_INSTANCE_DIALOG_OPEN_CHANGE:
      newState = {
        ...state,
        [EDIT_PROGRAM_INSTANCE_DIALOG_OPEN]: action[EDIT_PROGRAM_INSTANCE_DIALOG_OPEN],
        [EDITED_PROGRAM_INSTANCE]: action[EDITED_PROGRAM_INSTANCE] ? state[EDITED_PROGRAM_INSTANCE] : {}
      };
      break;
    case EDIT_PROJECT_DIALOG_OPEN_CHANGE:
      newState = {
        ...state,
        [EDIT_PROJECT_DIALOG_OPEN]: action[EDIT_PROJECT_DIALOG_OPEN],
        [EDITED_PROJECT]: action[EDIT_PROJECT_DIALOG_OPEN] ? state[EDITED_PROJECT] : {}
      };
      break;

    default:
      newState = { ...state };
      break;
  }

  return newState;
}

export function loadMasterData() {
  return (dispatch) => {
    dispatch(reloadFundingAreaList("masterDataManagament"));
  };
}

export function selectFundingArea(id) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch({
      [TYPE_KEY]: SELECTED_FUNDING_AREA_CHANGE,
      [SELECTED_FUNDING_AREA_ID]: id
    });
  };
}

export function selectProgram(id) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch({
      [TYPE_KEY]: SELECTED_PROGRAM_CHANGE,
      [SELECTED_PROGRAM_ID]: id
    });
  };
}

export function selectProgramInstance(id) {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch({
      [TYPE_KEY]: SELECTED_PROGRAM_INSTANCE_CHANGE,
      [SELECTED_PROGRAM_INSTANCE_ID]: id
    });
  };
}

export function createNewProgram() {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch({ [TYPE_KEY]: NEW_PROGRAM });
  };
}

export function createNewProgramInstance() {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch({ [TYPE_KEY]: NEW_PROGRAM_INSTANCE });
  };
}

export function createNewProject() {
  return (dispatch) => {
    dispatch(clearMessages());
    dispatch({ [TYPE_KEY]: NEW_PROJECT });
  };
}

export function editProgram(programId) {
  return (dispatch, getState) => {
    const fundingAreaList = getState().fundingArea[FUNDING_AREA_LIST].masterDataManagament;
    const selectedFundingAreaId = getState()[MASTER_DATA_STORE][SELECTED_FUNDING_AREA_ID];

    const selectedFundingArea = selectedFundingAreaId
      ? fundingAreaList.find((fa) => fa.id === selectedFundingAreaId)
      : undefined;
    const selectedProgram = selectedFundingArea.programs.find((program) => program.id === programId);

    dispatch(clearMessages());
    dispatch({
      [TYPE_KEY]: EDIT_PROGRAM,
      [EDITED_PROGRAM]: selectedProgram
    });
  };
}

export function editProgramInstance(programInstanceId) {
  return (dispatch, getState) => {
    const fundingAreaList = getState().fundingArea[FUNDING_AREA_LIST].masterDataManagament;
    const selectedFundingAreaId = getState()[MASTER_DATA_STORE][SELECTED_FUNDING_AREA_ID];
    const selectedProgramId = getState()[MASTER_DATA_STORE][SELECTED_PROGRAM_ID];

    const selectedFundingArea = selectedFundingAreaId
      ? fundingAreaList.find((fa) => fa.id === selectedFundingAreaId)
      : undefined;
    const selectedProgram = selectedFundingArea.programs.find((program) => program.id === selectedProgramId);
    const selectedProgramInstance = selectedProgram.programInstances.find(
      (programInst) => programInst.id === programInstanceId
    );

    dispatch(clearMessages());
    dispatch({
      [TYPE_KEY]: EDIT_PROGRAM_INSTANCE,
      [EDITED_PROGRAM_INSTANCE]: selectedProgramInstance
    });
  };
}

export function editProject(projectId) {
  return (dispatch, getState) => {
    const fundingAreaList = getState().fundingArea[FUNDING_AREA_LIST].masterDataManagament;
    const selectedFundingAreaId = getState()[MASTER_DATA_STORE][SELECTED_FUNDING_AREA_ID];
    const selectedProgramId = getState()[MASTER_DATA_STORE][SELECTED_PROGRAM_ID];
    const selectedProgramInstanceId = getState()[MASTER_DATA_STORE][SELECTED_PROGRAM_INSTANCE_ID];

    const selectedFundingArea = selectedFundingAreaId
      ? fundingAreaList.find((fa) => fa.id === selectedFundingAreaId)
      : undefined;
    const selectedProgram = selectedProgramId
      ? selectedFundingArea.programs.find((program) => program.id === selectedProgramId)
      : undefined;
    const selectedProgramInstance = selectedProgram.programInstances.find(
      (programInst) => programInst.id === selectedProgramInstanceId
    );

    dispatch(clearMessages());
    dispatch({
      [TYPE_KEY]: EDIT_PROJECT,
      [EDITED_PROJECT]: selectedProgramInstance.projects.find((project) => project.id === projectId)
    });
  };
}

export function saveProgram() {
  return (dispatch, getState) => {
    const program = getState()[MASTER_DATA_STORE][EDITED_PROGRAM];

    dispatch(beginLoading());

    if (program.id) {
      rest.doPut(`/admin/admin/program/${program.id}?customProgram=true`, JSON.stringify(program)).then(
        () => {
          dispatch(resetFundingAreaLists());
          dispatch(loadMasterData());
          dispatch(programDialogOpenChange(false));
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.save")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    } else {
      rest.doPost(`/admin/admin/program`, JSON.stringify(program)).then(
        () => {
          dispatch(resetFundingAreaLists());
          dispatch(loadMasterData());
          dispatch(programDialogOpenChange(false));
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.save")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    }
  };
}

export function saveProgramInstance() {
  return (dispatch, getState) => {
    const programInstance = getState()[MASTER_DATA_STORE][EDITED_PROGRAM_INSTANCE];

    dispatch(beginLoading());

    if (programInstance.id) {
      rest.doPut(`/admin/admin/programinstance/${programInstance.id}`, JSON.stringify(programInstance)).then(
        () => {
          dispatch(resetFundingAreaLists());
          dispatch(loadMasterData());
          dispatch(programInstanceDialogOpenChange(false));
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.save")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    } else {
      rest.doPost(`/admin/admin/programinstance`, JSON.stringify(programInstance)).then(
        () => {
          dispatch(resetFundingAreaLists());
          dispatch(loadMasterData());
          dispatch(programInstanceDialogOpenChange(false));
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.save")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    }
  };
}

export function saveProject() {
  return (dispatch, getState) => {
    const project = getState()[MASTER_DATA_STORE][EDITED_PROJECT];

    dispatch(beginLoading());

    if (project.id) {
      rest.doPut(`/admin/admin/project/${project.id}`, JSON.stringify(project)).then(
        () => {
          dispatch(resetFundingAreaLists());
          dispatch(loadMasterData());
          dispatch(projectDialogOpenChange(false));
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.save")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    } else {
      rest.doPost(`/admin/admin/project`, JSON.stringify(project)).then(
        () => {
          dispatch(resetFundingAreaLists());
          dispatch(loadMasterData());
          dispatch(projectDialogOpenChange(false));
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.save")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    }
  };
}

export function deleteProjectWithReferenceCheck(projectRefId) {
  return (dispatch) => {
    rest.doGet(`/survey/reportingperiod/countByProject?projectRefId=${projectRefId}`).then(
      (refCount) => {
        if (refCount <= 0) {
          dispatch(
            showDialog(
              projectRefId,
              (projectRefId) => dispatch(deleteProject(projectRefId)),
              "app.common.confirm.deletion",
              "master.data.management.confirm.delete.project",
              "confirmDialog.confirmLabel",
              "confirmDialog.dismissLabel"
            )
          );
        } else {
          dispatch(
            showDialog(
              {},
              () => {},
              "master.data.management.project.deletion.not.possible",
              "master.data.management.project.cannot.be.deleted",
              "confirmDialog.ok",
              null
            )
          );
        }
      },
      (reason) => {
        let error = JSON.parse(reason.response);
        dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
        dispatch(endLoading());
      }
    );
  };
}

export function deleteProject(projectId) {
  return (dispatch) => {
    dispatch(beginLoading());

    if (projectId) {
      rest.doDelete(`/admin/admin/project/${projectId}`).then(
        () => {
          dispatch(loadMasterData());
          dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.delete")));
          dispatch(endLoading());
        },
        (reason) => {
          let error = JSON.parse(reason.response);
          dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
          dispatch(endLoading());
        }
      );
    }
  };
}

export function deleteProgramInstance(programInstanceId) {
  return (dispatch) => {
    if (!programInstanceId) {
      return;
    }
    dispatch(
      showDialog(
        programInstanceId,
        (programInstanceId) => {
          dispatch(beginLoading());

          rest.doDelete(`/admin/admin/programinstance/${programInstanceId}`).then(
            () => {
              dispatch(loadMasterData());
              dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.delete")));
              dispatch(endLoading());
            },
            (reason) => {
              let error = JSON.parse(reason.response);
              dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
              dispatch(endLoading());
            }
          );
        },
        "",
        "master.data.management.confirm.delete.program.instance",
        "confirmDialog.confirmLabel",
        "confirmDialog.dismissLabel"
      )
    );
  };
}

export function deleteProgram(programId) {
  return (dispatch) => {
    if (!programId) {
      return;
    }

    dispatch(
      showDialog(
        programId,
        (programId) => {
          dispatch(beginLoading());

          rest.doDelete(`/admin/admin/program/${programId}`).then(
            () => {
              dispatch(loadMasterData());
              dispatch(messagesReceived(createSuccessMessages("master.data.management.button.successfully.delete")));
              dispatch(endLoading());
            },
            (reason) => {
              let error = JSON.parse(reason.response);
              dispatch(messagesReceived(createBackendErrorMessages(`${error.message}`)));
              dispatch(endLoading());
            }
          );
        },
        "",
        "master.data.management.confirm.delete.program",
        "confirmDialog.confirmLabel",
        "confirmDialog.dismissLabel"
      )
    );
  };
}

export function programChange(property, value) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: PROGRAM_CHANGE,
      property,
      value
    });
  };
}

export function programInstanceChange(property, value) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: PROGRAM_INSTANCE_CHANGE,
      property,
      value
    });
  };
}

export function projectChange(property, value) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: PROJECT_CHANGE,
      property,
      value
    });
  };
}

export function programDialogOpenChange(open) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: EDIT_PROGRAM_DIALOG_OPEN_CHANGE,
      EDIT_PROGRAM_DIALOG_OPEN: open
    });
  };
}

export function programInstanceDialogOpenChange(open) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: EDIT_PROGRAM_INSTANCE_DIALOG_OPEN_CHANGE,
      EDIT_PROGRAM_INSTANCE_DIALOG_OPEN: open
    });
  };
}

export function projectDialogOpenChange(open) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: EDIT_PROJECT_DIALOG_OPEN_CHANGE,
      EDIT_PROJECT_DIALOG_OPEN: open
    });
  };
}
